import React, { useRef, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { motion } from "framer-motion"
import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react"
import Heading from "../common/heading/Heading"
import "./HAbout.css"

const skillPrograms = [
  {
    id: "ai-ml",
    ProgramName: "Artificial Intelligence & Machine Learning",
    ProgramDescription: "Build intelligent systems using AI, machine learning, and generative technologies.",
    ImageURL: "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: "animation-vfx",
    ProgramName: "Animation, VFX & Gaming",
    ProgramDescription: "Create stunning visuals, animations, and game assets using industry tools.",
    ImageURL: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: "digital-marketing",
    ProgramName: "Digital Marketing & Content Creation",
    ProgramDescription: "Master marketing strategies, ads, and content creation for digital growth.",
    ImageURL: "https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: "data-science",
    ProgramName: "Data Science & Analytics",
    ProgramDescription: "Turn data into insights using analytics, Python, and business tools.",
    ImageURL: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: "ar-vr",
    ProgramName: "AR / VR Technology",
    ProgramDescription: "Build immersive experiences for metaverse and real-world applications.",
    ImageURL: "https://images.unsplash.com/photo-1622979135225-d2ba269cf202?q=80&w=800&auto=format&fit=crop"
  },
  {
    id: "robotics",
    ProgramName: "Robotics & Automation",
    ProgramDescription: "Design smart systems using robotics, IoT, and automation technologies.",
    ImageURL: "https://images.unsplash.com/photo-1485600645672-0391456a00cd?q=80&w=800&auto=format&fit=crop"
  }
];

const HAbout = () => {
  const navigate = useNavigate()
  const sliderRef = useRef(null)

  useEffect(() => {
    const slideTimer = setInterval(() => {
      if (sliderRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;
        if (scrollLeft + clientWidth >= scrollWidth - 10) {
          sliderRef.current.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          sliderRef.current.scrollBy({ left: 300, behavior: 'smooth' });
        }
      }
    }, 3500);
    return () => clearInterval(slideTimer);
  }, []);

  const slideLeft = () => {
    sliderRef.current.scrollBy({ left: -300, behavior: 'smooth' })
  }

  const slideRight = () => {
    sliderRef.current.scrollBy({ left: 300, behavior: 'smooth' })
  }

  return (
    <section className='homeAbout'>
      <div className='container'>
        <Heading
          subtitle='Industry-focused programs designed to build real-world skills.'
          title='Explore Our Skill Programs'
        />
        <div className="coursesCard" style={{ display: "flex", justifyContent: "center" }}>

          <div className="courses-carousel-wrapper">
            <button className="courses-nav-btn left" onClick={slideLeft}>
              <ChevronLeft size={24} />
            </button>

            <div className="courses-slider" ref={sliderRef}>
              {skillPrograms.map((course, idx) => (
                <motion.div
                  key={course.id}
                  initial={{ opacity: 0, scale: 0.95 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: idx * 0.1, duration: 0.4 }}
                  className="skill-program-card"
                  onClick={() => navigate(`/courses`)}
                >
                  <div className="skill-card-image">
                    <img
                      src={course.ImageURL}
                      alt={course.ProgramName}
                    />
                  </div>

                  <div className="skill-card-content">
                    <h3 className="skill-card-title">{course.ProgramName}</h3>
                    <p className="skill-card-desc">{course.ProgramDescription}</p>

                    <div className="skill-card-footer">
                      <button className="skill-card-btn">
                        <span>Explore Program</span>
                        <ArrowRight size={16} />
                      </button>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>

            <button className="courses-nav-btn right" onClick={slideRight}>
              <ChevronRight size={24} />
            </button>
          </div>

        </div>
      </div>
    </section>
  )
}

export default HAbout
